// @ts-nocheck
import React from 'react';
import initialState from '/azp/agent/_work/43/s/src/.umi-production/plugin-initial-state/models/initialState';
import model0 from "/azp/agent/_work/43/s/src/models/jsBridge";
import model1 from "/azp/agent/_work/43/s/src/models/testUseModel";
import model2 from "/azp/agent/_work/43/s/src/models/useAllCategory";
import model3 from "/azp/agent/_work/43/s/src/models/useAtmosphereDetailsModel";
import model4 from "/azp/agent/_work/43/s/src/models/useConfirmOrderModel";
import model5 from "/azp/agent/_work/43/s/src/models/useCouponModel";
import model6 from "/azp/agent/_work/43/s/src/models/useHomeModal";
import model7 from "/azp/agent/_work/43/s/src/models/useHousekeeperCommerce";
import model8 from "/azp/agent/_work/43/s/src/models/useMainHouseModel";
import model9 from "/azp/agent/_work/43/s/src/models/useProductDetailCacheModal";
import model10 from "/azp/agent/_work/43/s/src/models/useProductPropsModel";
import model11 from "/azp/agent/_work/43/s/src/models/useUploadDataModel";
import model12 from "/azp/agent/_work/43/s/src/models/useWxjsEnv";
// @ts-ignore
import Dispatcher from './helpers/dispatcher';
// @ts-ignore
import Executor from './helpers/executor';
// @ts-ignore
import { UmiContext } from './helpers/constant';

export const models = { '@@initialState': initialState, 'jsBridge': model0, 'testUseModel': model1, 'useAllCategory': model2, 'useAtmosphereDetailsModel': model3, 'useConfirmOrderModel': model4, 'useCouponModel': model5, 'useHomeModal': model6, 'useHousekeeperCommerce': model7, 'useMainHouseModel': model8, 'useProductDetailCacheModal': model9, 'useProductPropsModel': model10, 'useUploadDataModel': model11, 'useWxjsEnv': model12 };

export type Model<T extends keyof typeof models> = {
  [key in keyof typeof models]: ReturnType<typeof models[T]>;
};

export type Models<T extends keyof typeof models> = Model<T>[T]

const dispatcher = new Dispatcher!();
const Exe = Executor!;

export default ({ children }: { children: React.ReactNode }) => {

  return (
    <UmiContext.Provider value={dispatcher}>
      {
        Object.entries(models).map(pair => (
          <Exe key={pair[0]} namespace={pair[0]} hook={pair[1] as any} onUpdate={(val: any) => {
            const [ns] = pair as [keyof typeof models, any];
            dispatcher.data[ns] = val;
            dispatcher.update(ns);
          }} />
        ))
      }
      {children}
    </UmiContext.Provider>
  )
}
